import React from 'react';
import { Shield } from 'lucide-react';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="p-6 pt-8 min-h-[calc(100vh-4rem)]">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center space-x-4 mb-8">
          <div className="w-16 h-16 rounded-full bg-purple-500/20 flex items-center justify-center">
            <Shield className="w-8 h-8 text-purple-300" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-purple-200">Política de Privacidade</h1>
            <p className="text-purple-300/70">Última atualização: {new Date().toLocaleDateString()}</p>
          </div>
        </div>

        <div className="space-y-8 text-purple-200/90">
          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">1. Informações Coletadas</h2>
            <p>Coletamos as seguintes informações:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Nome completo</li>
              <li>Email</li>
              <li>Data e hora de nascimento</li>
              <li>Local de nascimento</li>
              <li>Informações de pagamento</li>
              <li>Dados de uso do serviço</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">2. Uso das Informações</h2>
            <p>Utilizamos suas informações para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Fornecer serviços astrológicos personalizados</li>
              <li>Processar pagamentos</li>
              <li>Enviar notificações importantes</li>
              <li>Melhorar nossos serviços</li>
              <li>Resolver problemas técnicos</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">3. Proteção de Dados</h2>
            <p>
              Implementamos medidas de segurança para proteger suas informações, incluindo:
            </p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Criptografia de dados sensíveis</li>
              <li>Acesso restrito a informações pessoais</li>
              <li>Monitoramento regular de segurança</li>
              <li>Backups seguros</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">4. Compartilhamento de Dados</h2>
            <p>
              Não vendemos ou compartilhamos suas informações pessoais com terceiros, exceto quando
              necessário para fornecer nossos serviços ou quando exigido por lei.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">5. Cookies e Tecnologias Similares</h2>
            <p>
              Utilizamos cookies e tecnologias similares para melhorar sua experiência, analisar o tráfego
              e personalizar o conteúdo.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">6. Seus Direitos</h2>
            <p>Você tem direito a:</p>
            <ul className="list-disc pl-6 mt-2 space-y-2">
              <li>Acessar seus dados pessoais</li>
              <li>Corrigir informações imprecisas</li>
              <li>Solicitar a exclusão de seus dados</li>
              <li>Opor-se ao processamento de dados</li>
              <li>Portabilidade dos dados</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">7. Alterações na Política</h2>
            <p>
              Podemos atualizar esta política periodicamente. Notificaremos sobre alterações significativas
              através de email ou aviso no site.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-purple-200 mb-4">8. Contato</h2>
            <p>
              Para questões sobre privacidade, entre em contato através do email: privacidade@celestialguide.com
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};